import { customTV } from '../../utils/tailwind';
export const divider = customTV({
    slots: {
        container: 'flex items-center gap-4',
        line: 'inline-block bg-[--background-var]',
    },
    variants: {
        orientation: {
            horizontal: {
                container: 'w-full',
                line: 'h-[--thickness-var] w-full',
            },
            vertical: {
                container: 'h-full flex-col',
                line: 'h-full w-[--thickness-var]',
            },
        },
        gradient: {
            rainbow: {
                line: 'bg-gradient-rainbow',
            },
            pink: {
                line: 'bg-gradient-pink',
            },
            green: {
                line: 'bg-gradient-green',
            },
            blue: {
                line: 'bg-gradient-blue',
            },
            purple: {
                line: 'bg-gradient-purple',
            },
        },
    },
});
